/**
 * @module http
 */

import {
    UnauthorizedApiError,
    GeneralApiError,
    ForbiddenApiError,
    InternalError,
    ConfictApiError,
} from './error';
import { authUrl } from './const';

const { location } = window;

/**
 * @name request
 * @desc Makes a request to backend api.
 * @param {string} uri
 * @param {{}} [data]
 * @param {string} [method]
 * @param {boolean} [noRedirect]
 * @returns {Promise<{}>}
 * @throws {UnauthorizedApiError}
 * @throws {GeneralApiError}
 * @async
 * @public
 */
export async function request(
    uri,
    data = null,
    method = 'POST',
    noRedirect = false
) {
    let body;
    if (data) {
        body = JSON.stringify(data);
    }
    let res;
    try {
        res = await fetch(uri, { method, body, credentials: 'include' });
    } catch (err) {
        throw new GeneralApiError({ error: err.message });
    }
    if (res.status === 204) {
        // server returned "no content" status, nothing to parse
        return {};
    }
    let resData;
    try {
        resData = await res.json();
    } catch (err) {
        resData = {};
    }
    switch (res.status) {
        // no content
        case 204:
            return {};

        // unauthorized
        case 401:
            if (!noRedirect) {
                location.assign(authUrl);
            }
            throw new UnauthorizedApiError(resData);

        // forbidden
        case 403:
            throw new ForbiddenApiError(resData);

        // conflict
        case 409:
            throw new ConfictApiError(resData);

        // catch all
        default:
            if (res.status >= 200 && res.status < 300) {
                // ok
                return resData;
            } else if (res.status >= 500 && res.status < 600) {
                // internal server error
                throw new InternalError(resData);
            }
            // unknown server error
            throw new GeneralApiError(resData);
    }
}
